import { useMemo } from "react";
import { CreateCartPayload } from "shared/api/middleware-api-client";

interface ProductAnalysis {
  someAkoestischepanelen: boolean;
  someAccessoire: boolean;
  someAccessoireAkoestischPaneel: boolean;
}

export function useStandardProductType(cart: CreateCartPayload) {
  const productAnalysis: ProductAnalysis = useMemo(() => {
    // Check if there are any products with productType code "accessoire" or "kleurstaalakoestischepanelen"
    const someAccessoire = cart.standardProducts.some(
      (product) =>
        product.productType.code === "accessoire" ||
        product.productType.code === "kleurstaalakoestischepanelen",
    );

    // Check if there are any products with productType code "akoestischepanelen"
    const someAkoestischepanelen = cart.standardProducts.some(
      (product) => product.productType.code === "akoestischepanelen",
    );

    // Check if there are any products with productType code "accessoireakoestischpaneel"
    const someAccessoireAkoestischPaneel = cart.standardProducts.some(
      (product) => product.productType.code === "accessoireakoestischpaneel",
    );

    return {
      someAkoestischepanelen: someAkoestischepanelen,
      someAccessoire: someAccessoire,
      someAccessoireAkoestischPaneel,
    };
  }, [cart.standardProducts]);

  return productAnalysis;
}
